const GTM_PREVIEW_COOKIE_NAME = '__TAG_ASSISTANT';
const isGtmPreview = ({
  query,
  cookies
}) => {
  return cookies?.[GTM_PREVIEW_COOKIE_NAME] || query?.gtm_debug;
};
export default isGtmPreview;